import { Icon } from "components/Icon/Icon";
import { IconCollection } from "components/Icon/IconCollection";
import StatusBadge from "components/StatusBadge";
import { MdiReactIconComponentType } from "mdi-react";
import style from "./IconWithStatusBadge.module.scss";

export const IconWithStatusBadge = ({ statusBadgeProps, icon, statusBadgeClassName }: any) => (
    <span className={style.iconWithStatusBadge}>
        <Icon icon={icon} className="button__icon" />
        <StatusBadge
            round
            {...statusBadgeProps}
            className={`${style.statusBadge} ${statusBadgeClassName ?? ""}`}
        />
    </span>
);

export const UncommittedStatusBadgeImage = ({
    uncommittedChangesCount,
}: {
    uncommittedChangesCount: number;
}) => (
    <IconWithStatusBadge
        icon={IconCollection.uploadMultiple}
        statusBadgeProps={{
            type: "primary-red",
            text: String(uncommittedChangesCount),
            size: "smallText",
        }}
        statusBadgeClassName={style.bigButtonStatusBadge}
    />
);

export const getUncommittedStatusBadgeIcon = (
    uncommittedChangesCount: number
): MdiReactIconComponentType =>
    uncommittedChangesCount ? (null as any) : IconCollection.uploadMultiple;
